
import { Component } from 'vue-property-decorator';
import ElementBase from '../ElementBase';
import { WindowType } from '../../../../util';
import HelpModal from './HelpModal';

declare var window: WindowType;

@Component({
  name: 'TitleBar',
  components: { HelpModal },
})
export default class TitleBar extends ElementBase {
  get baseUrl(): string {
    return window.application.baseUrl;
  }
  
  openHelpModal(): void {
    (this.$refs.helpModal as HelpModal).open();
  }
}
